import React from 'react';
import ListItem from 'material-ui/List/ListItem';
import Avatar from 'material-ui/Avatar';
import {picdata} from '../../Interfaces/picdata';

interface PictureListProps {
  picdate: picdata;
}

export default class PictureList extends React.Component<PictureListProps, undefined> {
  render() {
    const {picdate: date = {}} = this.props;
    const {标题 = '', 项目名称 = '', 奖项等第 = '', 姓名 = '', 路径 = '', 分类 = '', 日期 = ''} = date;
    return (
      <ListItem
        primaryText={标题}
        secondaryText={项目名称 + ' ' + 奖项等第 + ' ' + 姓名 + ' ' + 日期}
        leftAvatar={<Avatar src={路径} />}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PictureList/index.tsx